import { FinancialInstitutionEntity } from '../entities/financial-institution-entity';

export default class State {
  loaded = false;

  items: Array<FinancialInstitutionEntity> = [];
}
